var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "container-fluid" }, [
    _c(
      "div",
      { staticClass: "row no-gutters pb-2", attrs: { "data-cs-mask": "" } },
      [
        _c(
          "div",
          { staticClass: "col-12 px-0" },
          [
            _c("EligibilityInfo", {
              attrs: {
                "eligibility-info": _vm.eligibilityResult.eligibilityInfo,
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showBottomElipiLink
          ? _c("div", { staticClass: "col-12 px-1 px-md-0 mt-1" }, [
              _c(
                "button",
                {
                  staticClass: "ob1-link-arrow",
                  attrs: {
                    type: "submit",
                    form: "tester-eligibilite",
                    name: "position",
                    value: _vm.eligibilityResult.position,
                    "data-oevent-category":
                      _vm.eligibilityResult.linkTms.category,
                    "data-oevent-label": _vm.eligibilityResult.linkTms.label,
                    "data-oevent-action": _vm.eligibilityResult.linkTms.action,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.eligibilityResult.elipiLabel) +
                      "\n            "
                  ),
                ]
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }